/* Wishlist / favourites — INXL World.
 * Ported from the Woo wishlist-store.ts (Zustand + localStorage) + WishHeart.tsx.
 *
 * localStorage-backed, no backend. Each hearted product stores a small display
 * snapshot {id, handle, url, title, image, price, vendor} captured from the card
 * at click time, so the /wishlist page renders instantly with zero fetches.
 * Any [data-wish-toggle] button toggles; hearts, header counts and the wishlist
 * page stay in sync via a 'wishlist:change' event (+ cross-tab 'storage').
 * Exposes window.__wishlist = { read, has, toggle, count }.
 */
(function () {
  var KEY = 'inxl_wishlist';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function idList() { return read().map(function (x) { return String(x.id); }); }
  function has(id) { return idList().indexOf(String(id)) !== -1; }
  function count() { return read().length; }

  function toggle(item) {
    var list = read();
    var idx = list.map(function (x) { return String(x.id); }).indexOf(String(item.id));
    var added = idx === -1;
    if (added) list.unshift(item); else list.splice(idx, 1);
    write(list);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: count() } }));
    return added;
  }

  function clear() {
    write([]);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: 0 } }));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Artist display name — mirror of snippets/artist-name.liquid (Aquarium's vendor is
  // the person's name in Shopify; the site shows «Аквариум | БГ+»).
  function displayVendor(v) {
    var s = String(v == null ? '' : v);
    return /grebensh|гребенщ/i.test(s) ? 'Аквариум | БГ+' : s;
  }

  function syncHearts() {
    document.querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-wish-id'));
      btn.classList.toggle('is-wished', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-wish-label]');
      var text = on ? 'Remove from wishlist' : 'Add to wishlist';
      if (label) label.textContent = text;
      btn.setAttribute('aria-label', text);
    });
  }

  function syncCount() {
    var n = count();
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }

  var HEART = '<svg class="wish-heart__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20 C12 20 3.5 15 3.5 8.9 C3.5 6.1 5.7 4 8.3 4 C10 4 11.4 5 12 6.3 C12.6 5 14 4 15.7 4 C18.3 4 20.5 6.1 20.5 8.9 C20.5 15 12 20 12 20 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  function cardHTML(it) {
    // Simple products get a quick "Add to cart"; products with real options (or
    // pre-existing snapshots that lack a variant id) link to the PDP to choose.
    var canQuickAdd = it.variantId && !it.optioned;
    var addEl = canQuickAdd
      ? '<button type="button" class="wishlist__add" data-wish-add data-variant="' + esc(it.variantId) + '">Add to cart</button>'
      : '<a class="wishlist__add wishlist__add--link" href="' + esc(it.url) + '">Choose options</a>';
    return '<div class="wishlist__card">' +
      '<a class="wishlist__media" href="' + esc(it.url) + '" aria-label="' + esc(it.title) + '">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') +
      '</a>' +
      '<button type="button" class="wish-heart is-wished" data-wish-toggle aria-pressed="true" aria-label="Remove from wishlist"' +
        ' data-wish-id="' + esc(it.id) + '" data-wish-handle="' + esc(it.handle) + '" data-wish-url="' + esc(it.url) + '"' +
        ' data-wish-title="' + esc(it.title) + '" data-wish-image="' + esc(it.image) + '" data-wish-price="' + esc(it.price) + '" data-wish-vendor="' + esc(displayVendor(it.vendor)) + '"' +
        ' data-wish-variant="' + esc(it.variantId) + '" data-wish-optioned="' + (it.optioned ? '1' : '') + '">' +
        HEART + '<span class="wish-heart__label" data-wish-label>Remove from wishlist</span></button>' +
      '<a class="wishlist__body" href="' + esc(it.url) + '">' +
        (it.vendor ? '<span class="wishlist__brand">' + esc(displayVendor(it.vendor)) + '</span>' : '') +
        '<span class="wishlist__name">' + esc(it.title) + '</span>' +
        '<span class="wishlist__price">' + esc(it.price) + '</span>' +
      '</a>' +
      addEl +
    '</div>';
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist]');
    if (!root) return;
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var countEl = root.querySelector('[data-wishlist-count]');
    var list = read();
    var clearBtn = root.querySelector('[data-wishlist-clear]');
    if (clearBtn) clearBtn.hidden = list.length === 0;
    if (countEl) {
      countEl.textContent = list.length + (list.length === 1 ? ' item' : ' items');
      countEl.hidden = list.length === 0;
    }
    if (!list.length) {
      if (grid) { grid.hidden = true; grid.innerHTML = ''; }
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (grid) {
      grid.hidden = false;
      // Render the SAME product card as catalog / home / recommendations by
      // fetching each product's card-only view (?view=card → templates/product.card
      // .liquid) and injecting it — so wishlist cards have full options / price /
      // add-to-cart, identical to everywhere else. product-card.js inits them.
      grid.innerHTML = list.map(function () { return '<div class="wishlist__slot"></div>'; }).join('');
      var slots = grid.children;
      list.forEach(function (it, i) {
        if (!it.handle) return;
        fetch('/products/' + encodeURIComponent(it.handle) + '?view=card', { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var slot = slots[i];
            if (slot && html) slot.innerHTML = html;
            if (window.__productCards && window.__productCards.init) window.__productCards.init();
            syncHearts();
          })
          .catch(function () {});
      });
    }
  }

  function sync() { syncHearts(); syncCount(); renderPage(); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({
      id: btn.getAttribute('data-wish-id'),
      handle: btn.getAttribute('data-wish-handle'),
      url: btn.getAttribute('data-wish-url'),
      title: btn.getAttribute('data-wish-title'),
      image: btn.getAttribute('data-wish-image'),
      price: btn.getAttribute('data-wish-price'),
      vendor: btn.getAttribute('data-wish-vendor'),
      variantId: btn.getAttribute('data-wish-variant'),
      optioned: btn.getAttribute('data-wish-optioned') === '1'
    });
  });

  // Quick add-to-cart from a wishlist card (simple products only; optioned ones
  // render a "Choose options" link to the PDP instead).
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-wish-add]');
    if (!add) return;
    e.preventDefault();
    var vid = add.getAttribute('data-variant');
    if (!vid) return;
    add.disabled = true;
    var prev = add.textContent;
    add.textContent = 'Adding…';
    var p = (window.__cart && window.__cart.addToCart)
      ? window.__cart.addToCart(vid, 1)
      : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    p.then(function () {
      add.disabled = false;
      add.textContent = 'Added ✓';
      if (window.__cart && window.__cart.openDrawer) window.__cart.openDrawer();
    }).catch(function () { add.disabled = false; add.textContent = prev; });
  });

  document.addEventListener('wishlist:change', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-clear]')) { e.preventDefault(); clear(); }
  });

  window.__wishlist = { read: read, has: has, toggle: toggle, count: count, clear: clear, syncHearts: syncHearts };

  sync();
})();
